import drill_title from "@/components/drill_title.vue"
import jqUaAddcls from "@/assets/js/functions/jquery.ua_addclass.js"
import jsRdm from "@/assets/js/functions/getRandom.js"
import jsLsObj from "@/assets/js/functions/resetLsData.js"
import jsReset from "@/assets/js/functions/resetSaveObj.js"
import jsStg from "@/assets/js/functions/class_localStorage.js"
import jqFixed from "@/assets/js/functions/class_jqFixedWindow.js"
var ls = new jsStg.jsLocalStorage();
var fw = new jqFixed.jqfixedWindow();

export default {
	name: "selection",
	props: {
		title: String,
		title_html: String,
		title_id: String,
		ls_key: String,
		jsonObj: Object,
		SettingObj: Object,
	},
	components: {
		drill_title,
	},
	data: function() {
		return {
			random: false,
			headerTitle: "",
			qLength: 0,
			percent: 0,
			bool: {howto: false, cache_q: false, incorrect_btn: false, bookmark_btn: false},
			data: {howto: ""},
			bgcolors: {
				text: {color: this.SettingObj.bgcolors.text},
				header: {background: this.SettingObj.bgcolors.header},
				footer: {background: this.SettingObj.bgcolors.footer},
				belt: {background: this.SettingObj.bgcolors.belt},
				startbutton: {background: this.SettingObj.bgcolors.startbutton},
				startbutton_sub: {background: this.SettingObj.bgcolors.startbutton_sub},
				button_heavy: {background: this.SettingObj.bgcolors.button_heavy, borderBottom: this.SettingObj.bgcolors.button_heavy_thick},
			},
		}
	},
	created: function() {
		var ls_data = ls.getStorageJson(this.ls_key);

		// URLパラメータ（/selection?h=n）からの初見アクセスなど、保存データが存在しない場合は初期化（Home.vueと共通）
		if (!ls_data) {
			ls_data = jsLsObj.resetLsData(this.title, this.title_id); // ls_data Objを初期化
			ls_data.saveAry = jsReset.resetSaveObj(this.jsonObj.qAry); // ls_data.saveAry[n]の初期化
		}
		// URLパラメータ（/selection?h=n）がある場合はカレントの単元IDを変更
		var url_param = Number(this.$route.query.h);
		if (url_param >= 0) {
			ls_data.current_head_id = url_param;
		}

		var head_id = ls_data.current_head_id;
		this.bool.cache_q = (0 < ls_data.saveAry[head_id].cache.q)? true : false;

		this.headerTitle = this.jsonObj.qAry[head_id].header;
		this.qLength = this.jsonObj.qAry[head_id].questions.length;	
		this.percent = (!ls_data.saveAry[head_id].percent)? 0 : ls_data.saveAry[head_id].percent; // 成績パーセントデータを取得

		ls_data.continueBool = false; // 「続きから解く」の初期化
		ls_data.incorrectBool = false; // 「不正解の問題だけ解く」の初期化
		ls_data.bookmarkBool = false; // 「登録した問題を解く」の初期化
		this.random = (!ls_data.randomBool)? false : true; // シャッフル論理値の保存状態を取得して復帰

		ls.setStorageJson(this.ls_key, ls_data);
		return;
	},
	mounted: function() {
		// ユーザーエージェントよりclass属性（ua_sp、ua_tb、ua_pc）を追加
		jqUaAddcls.ua_addclass();
	},
	computed: {
		incorrectLength: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var incorrectLength = 0;
			const correctAry = ls_data.saveAry[ls_data.current_head_id].correctAry;
			if (correctAry) {
				for (var i = 0; i < correctAry.length; i++) {
					const id = correctAry[i].id;
					if (!correctAry[id].bool) {
						incorrectLength++;
					}
				}
			}
			return incorrectLength;
		},
		bookmarkLength: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var bookmarkLength = 0;
			const bookmarkAry = ls_data.saveAry[ls_data.current_head_id].bookmarkAry;
			if (bookmarkAry) {
				for (var i = 0; i < bookmarkAry.length; i++) {
					const id = bookmarkAry[i].id;
					if (bookmarkAry[id].bool) {
						bookmarkLength++;
					}
				}
			}
			return bookmarkLength;
		},
		finishBool: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			return ls_data.saveAry[ls_data.current_head_id].finishBool;
		},
	},
	methods: {
		// アプリの使い方ボタンイベント
		viewHowto: function() {
			const howto = this.SettingObj.howto;
			if (!this.bool.howto) {
				this.data.howto = howto;
				this.bool.howto = true;
				fw.fixedWindow(".help_window"); // 背面スクロールを禁止（jQuery）

			} else {
				this.data.howto = "";
				this.bool.howto = false;
				fw.releaseWindow(".help_window"); // 背面スクロール禁止を解除
			}
		},
		checkRandom: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			ls_data.randomBool = (this.random)? true : false;
			// シャッフル適用時は「不正解の問題だけ解く」はオフに
			this.bool.incorrect_btn = (!this.finishBool || !this.incorrectLength || this.random)? false : true;
			// シャッフル適用時は「登録した問題を解く」はオフに
			this.bool.bookmark_btn = (!this.bookmarkLength || this.random)? false : true;

			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// 最初から全部解く
		runStart: function() {
			var i;
			var ls_data = ls.getStorageJson(this.ls_key);
			var head_id = ls_data.current_head_id;
			ls_data.saveAry[head_id].lastVisitedPage = 'general';
			ls_data.saveAry[head_id].current =  this.jsonObj.qAry[head_id].questions[0].id; // いちばん最初の出題ID
			ls_data.saveAry[head_id].index = 0;
			ls_data.saveAry[head_id].cache.q = 0;
			ls_data.saveAry[head_id].cache.a = 0;

			// 選択単元ごとで正解情報をすべてリセット
			if (ls_data.saveAry[head_id].correctAry) {
				for (i = 0; i < ls_data.saveAry[head_id].correctAry.length; i++) {
					ls_data.saveAry[head_id].correctAry[i].bool = false;
					ls_data.saveAry[head_id].correctAry[i].select = null;
				}
				ls_data.saveAry[head_id].finishBool = false;
			}

			// 選択単元毎のランダム情報配列を生成
			ls_data.saveAry[head_id].randomAry = [];
			var getRandomAry = jsRdm.getRandom(this.qLength, this.qLength, false);
			for (i = 0; i < getRandomAry.length; i++) {
				const id = this.jsonObj.qAry[head_id].questions[i].id;
				ls_data.saveAry[head_id].randomAry[id] = {
					id: id, // 各単元の設問ID
					random: this.jsonObj.qAry[head_id].questions[getRandomAry[i]].id, // ランダム処理後ID
				};			
			}

			ls.setStorageJson(this.ls_key, ls_data);
			this.$router.push("/1");
			return;
		},
		// 続きから解く
		runContinue: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var head_id = ls_data.current_head_id;
			var lastVisitedPage = ls_data.saveAry[head_id].lastVisitedPage
		
			ls_data.continueBool = true;
			ls_data.saveAry[head_id].current+1

			var setPath = "/"+(ls_data.saveAry[head_id].current+1);
			if(lastVisitedPage === 'incorrect'){
				ls_data.incorrectBool = true;
			}
				
			if(lastVisitedPage === 'bookmark'){
				ls_data.bookmarkBool = true;
			}
				
			ls.setStorageJson(this.ls_key, ls_data);
			this.$router.push(setPath);
			return;
		},
		// 不正解の問題だけ解く
		runIncorrect: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var head_id = ls_data.current_head_id;
			ls_data.incorrectBool = true;
			ls_data.saveAry[head_id].lastVisitedPage = 'incorrect';
			ls_data.saveAry[head_id].cache.q = 0;
			ls_data.saveAry[head_id].cache.a = 0;

			var setPath = "/1";
			const correctAry = ls_data.saveAry[head_id].correctAry;
			for (var i = 0; i < correctAry.length; i++) {
				if (!correctAry[correctAry[i].id].bool) {
					setPath = "/"+(i+1);
					ls_data.saveAry[head_id].current = i; //set current page
					break;
				}
			}
			ls.setStorageJson(this.ls_key, ls_data);
			this.$router.push(setPath);
			return;
		},
		// 登録した問題を解くイベント
		runSaveQuestion: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var head_id = ls_data.current_head_id;

			ls_data.bookmarkBool = true;
			ls_data.saveAry[head_id].lastVisitedPage = 'bookmark';
			ls_data.saveAry[head_id].cache.q = 0;
			ls_data.saveAry[head_id].cache.a = 0;

			var setPath = "/1";
			const bookmarkAry = ls_data.saveAry[head_id].bookmarkAry;
			for (var i = 0; i < bookmarkAry.length; i++) {
				const id = bookmarkAry[i].id;
				if (bookmarkAry[id].bool) {
					setPath = "/"+(i+1);
					ls_data.saveAry[head_id].current = i; //set current page
					break;
				}
			}
			
			ls.setStorageJson(this.ls_key, ls_data);
			this.$router.push(setPath);
			return;
		},
	},
}
